/**
 * 描述：租户管理--新建编辑弹框
 * 日期：2017-11-16
 * 作者：liu_jinming
 */
"use strict";
angular.module("tenantServicesInfoModule", ['tManageMentServiceModule'])
    .controller("tenantServicesInfoCtrl", ["$scope", "$modalInstance", "trsHttpService", "item", "modalDialog", "$validation", "dateFilter", "$element", function($scope, $modalInstance, trsHttpService, item, modalDialog, $validation, dateFilter, $element) {
        initStatus();
        initData();
        /** [initStatus description] 初始化数据 */
        function initStatus() {
            $scope.data = {
                copyCurrPage: 1,
                tanentServiceList: [],
                selectedServiceList: []
            };
            $scope.page = {
                ITEMCOUNT: 0,
                PAGESIZE: 20,
                CURRPAGE: 1,
                PAGECOUNT: 0
            };
            $scope.status = {
                searchWord: '',
                tenantId: item.TENANTID,
                modifyTime: true
            };
        }
        /** [initData description] 初始化话数据 */
        function initData() {
            requestServices();
        }
        /** [requestData description]获取服务项的初始化数据 */
        function requestServices() {
            var params = {
                serviceid: 'mlf_tenant',
                methodName: 'adminQueryUsedServiceConfig',
                CURRPAGE: $scope.page.CURRPAGE,
                PAGESIZE: $scope.page.PAGESIZE,
                TENANTID: $scope.status.tenantId
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                for(var i in data.DATA){
                    if(data.DATA[i].STARTTIME == ''){
                        delete data.DATA[i].STARTTIME;
                        delete data.DATA[i].ENDTIME;
                    }
                }
                $scope.data.tanentServiceList = data.DATA;
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
            });
        }
        /** [search description] 服务搜索 */
        // $scope.search = function() {
        //     requestServices();
        // };
        /** [requestData description] 分页信息改变时候的请求数据 */
        $scope.requestData = function() {
            $scope.data.copyCurrPage = $scope.page.CURRPAGE;
            requestServices();
        };
        $scope.jumpToPage = function() {
            $scope.page.CURRPAGE = $scope.data.copyCurrPage;
            requestServices();
        };
        /** [switchStatus description] 转换服务的状态 */
        $scope.switchStatus = function(item) {
            if (item.TENANTSUBSERVICESTATUS == '1') {
                modalDialog.alertType("", "确定停用？", 'ask', true, function() {
                    item.TENANTSUBSERVICESTATUS = '0';
                    item.haserror = false; //停用服务的情况下就不用再去管有效期
                }, function() {});
            } else {
                modalDialog.alertType("", "确定启用？", 'ask', true, function() {
                    item.TENANTSUBSERVICESTATUS = '1';
                    if (!item.STARTTIME || !item.ENDTIME) {
                        item.haserror = true;
                    } else {
                        item.haserror = false;
                    }
                }, function() {});
            }
        };
        /** [cho oseTime description]组件绑定的时间修改 */
        $scope.chooseTime = function(item) {
            if ($scope.status.modifyTime) {
                $scope.status.modifyTime = false; //用于防抖动 稿回调事件 会连续触发让其值触发一次
                modalDialog.alertType("", "确定修改有效期?", 'ask', true, function() {
                    $scope.status.modifyTime = true;
                    var today = Date.parse(dateFilter(new Date(), 'yyyy-MM-dd'));
                    if (item.ENDTIME === '' && item.STARTTIME === '') { //在删除时间的同时将起止时间的两个字段删除避免混淆
                        item.haserror = true;
                        return;
                    }
                    if (Date.parse(item.ENDTIME) <= today) {
                        item.haserror = true;
                        modalDialog.alertType("", "有效期失效日期需要大于今日!", 'error', 'confirm');
                    } else {
                        item.haserror = false;
                    }
                }, function() {
                    $scope.status.modifyTime = true;
                });
            }
        };
        /** [cancel description]点击取消的操作 */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        /** [confirm description] 点击确定保存修改的时候对服务项的数据进行处理*/
        $scope.confirm = function() {
            var array = [],
                flag1 = true, //有效期是否填写的标识
                flag2 = true, //有效期是否有效的标识
                todaytimeArr = [], //保存有效期错误的服务名数组
                notimeArr = [], //保存未填写有效期的服务名数组
                today = Date.parse(dateFilter(new Date(), 'yyyy-MM-dd')); //取今天得时间戳作为有效期校验的标准
            for (var i in $scope.data.tanentServiceList) { //保存时检查数组循环数组检查数据格式
                var obj = $scope.data.tanentServiceList[i]; //实例化一个服务的对象
                if (obj.TENANTSUBSERVICESTATUS == 1 && !obj.STARTTIME && !obj.ENDTIME) { //只有在开启状态下才去检查他的有效期
                    notimeArr.push(obj.SERVICENAME);
                    obj.haserror = true;
                    flag1 = false;
                }
                var startTime = dateFilter(obj.STARTTIME, 'yyyy-MM-dd'),
                    endTime = dateFilter(obj.ENDTIME, 'yyyy-MM-dd');
                if (obj.TENANTSUBSERVICESTATUS == 1 && Date.parse(endTime) <= today) { //只要存在的时间不符合开启服务的条件就不符合
                    todaytimeArr.push(obj.SERVICENAME);
                    obj.haserror = true;
                    flag2 = false;
                }
                var httpobj = { status: !obj.TENANTSUBSERVICESTATUS ? '0' : obj.TENANTSUBSERVICESTATUS, serviceConfigID: obj.SERVICECONFIGID, startTime: !startTime ? '' : startTime, endTime: !endTime ? '' : endTime };
                array.push(httpobj);
            }
            if (!flag1) { //在时间有未填写的情况下拦截并做提示
                modalDialog.alertType("", notimeArr.join(',') + "未设置有效期!", "error", 'confirm');
                return;
            }
            if (!flag2) { //在时间有错误的情况下拦截并做提示
                modalDialog.alertType("", todaytimeArr.join(',') + "的失效期必须大于今日!", "error", 'confirm');
                return;
            }
            var CONFIGLIST = {
                tenantID: item.TENANTID,
                serviceConfigInfo: array
            };
            CONFIGLIST = JSON.stringify(CONFIGLIST); //将数据格式转化为JSON格式
            changService(CONFIGLIST);
        };
        /** [changService description]得到处理完的数据 请求接口修改服务项配置 */
        function changService(info) {
            var params = {
                serviceid: 'mlf_tenant',
                methodName: 'operationServiceConfig',
                CONFIGLIST: info
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (data) {
                    modalDialog.alertType("", "修改成功", "success", false);
                    $modalInstance.dismiss();
                }
            }, function(data) {
                if(!!data.REPORTS){
                    $modalInstance.dismiss();
                }  
            });
        }
        /** [positionTime description]在点击日期控件的同时计算以及定位弹出的选择日历 */
        // $scope.positionTime = function (e, num){
        //     var box = $(e.target),
        //         body = $element.find(".body"),
        //         bodyOffsetTop = body.offset().top,
        //         bodyHeight = body.height(),
        //         boxHeight = box.height(),
        //         boxOffsetTop = box.offset().top;
        //     if(bodyHeight-boxOffsetTop+bodyOffsetTop < 365){//计算需要定位的下部空间
        //         body[0].scrollTop = 86 + (num - 1)*45;//适配各个不同的空定位都适合位置
        //     }
        // };
    }]);